import { render } from "./expires-link.vue?vue&type=template&id=7d1c5174"
import script from "./expires-link.vue?vue&type=script&lang=js"
export * from "./expires-link.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__